/**
 * Shared theme constants for the reviewer PDF report (telecom_v2 redesign).
 * Centralised so cover, profile and executive pages render with identical
 * brand colors, spacing and typography.
 */

export type RGB = [number, number, number];

export const REPORT_THEME = {
  // Deep brand navy used on report headers/bands.
  navy: { hex: "#0B1F3A", rgb: [11, 31, 58] as RGB },
  // Lighter accent blue used for table headers / borders.
  accent: { hex: "#1F4E79", rgb: [31, 78, 121] as RGB },
  // Subtle table row alt + dividers.
  surfaceAlt: { hex: "#F4F7FB", rgb: [244, 247, 251] as RGB },
  border: { hex: "#D7DEE8", rgb: [215, 222, 232] as RGB },
  // Text tokens.
  textPrimary: { rgb: [30, 30, 30] as RGB },
  textMuted: { rgb: [110, 110, 110] as RGB },
  textOnNavy: { rgb: [255, 255, 255] as RGB },
  // Gold accent (small underlines under labels).
  gold: { hex: "#C9A227", rgb: [201, 162, 39] as RGB },
} as const;

export const PAGE_MARGIN = 40;

/** Standard date format: "April 29, 2025". */
export function formatLongDate(value?: string | Date | null): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
}

/** "April 29, 2025 – June 15, 2026" (en-dash, em-spacing). */
export function formatEngagementPeriod(start?: string | null, end?: string | null): string {
  const s = formatLongDate(start);
  const e = formatLongDate(end);
  if (s === "—" && e === "—") return "—";
  return `${s} – ${e}`;
}
